export default __webpack_public_path__ + "static/media/A11.62fba271.png";